/** Sidebar Rules — click opens rules.cls in the MetadataEditorPanel. */
import { useCallback } from "react";
import { Settings } from "lucide-react";
import { getUserRules } from "../devAgentService";
import { useAuthStoreV1 } from "@/stores/authStore_v1";
import { useDevAgentStore } from "@/stores/devAgentStore";

const DEFAULT_RULES_TEMPLATE = `# nCoder Rules

## Apex Standards
- All triggers must use handler pattern (no logic in trigger body)
- Bulkify all SOQL — never query inside loops
- Use custom exceptions, never generic Exception catch

## Naming Conventions
- Trigger: ObjectName + Trigger (e.g. AccountTrigger)
- Handler: ObjectName + TriggerHandler
- Test class suffix: always + Test

## Forbidden Patterns
- No hardcoded IDs
- No @future methods — use Queueable instead
- Never use addError() in a loop

## Org-Specific
- Add your org-specific rules here
`;

export function SidebarRules({ userId }: { userId: string }) {
  const selectedOrgId = useAuthStoreV1((s) => s.selectedOrg?.id || "");

  const openRulesInEditor = useCallback(async () => {
    if (!userId || !selectedOrgId) return;
    try {
      const rules = await getUserRules(selectedOrgId);
      const content = rules.length > 0 ? rules[0].text : DEFAULT_RULES_TEMPLATE;

      const store = useDevAgentStore.getState();
      store.addVirtualFile("rules.cls", { content, metadataType: "ApexClass", name: "rules.cls" });
      store.setEditorOpen(true);
      store.setPendingFile({ id: "rules.cls", name: "rules.cls", metadataType: "ApexClass", content });
    } catch { /* silent */ }
  }, [selectedOrgId, userId]);

  return (
    <div className="border-b">
      <button onClick={openRulesInEditor} className="flex items-center gap-2 w-full text-left hover:bg-muted/50 px-4 py-2 transition-colors">
        <Settings className="w-3.5 h-3.5 text-muted-foreground" />
        <span className="font-semibold text-sm flex-1">Rules</span>
      </button>
    </div>
  );
}
